<script>
import {
  required,
  requiredIf,
  numeric,
  maxLength,
  minLength,
} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

// Custom Components
import DataUpdateInfo from "@/components/dataUpdateInfo.vue";
import PbxService from "@/helpers/APIService/pbx.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { time_zones, pmsType } from "@/helpers/global.variable";

export default {
  data() {
    return {
      domain_form: {
        domain_name: "",
        domain_enabled: true,
        domain_description: "",
        pbx: "",
        ip: "",
        domain_timezone: "",
        stripe_customer_id: "",
        domain_subscription: {
          text: "Active",
          value: "active",
        },
        main_cid: "",
        main_name: "",
        emr_cid: "",
        emr_name: "",
        vpn_ip: "",
        audiomsg: "",
        audiofile: "",
        dailyvmaildel: "",
        staffauth: "",
        vm_admin_pin: "",
        extension_limit: "",
        pms_type: "",
        is_send_data_to_pms: false,
        pms_id: "",
      },
      domain_uuid: "",
      submitted: false,
      isBtnLoading: false,
      iserror: false,
      main_domain: { text: "cloudext.co", value: "cloudext.co" },
      domainOptions: [{ text: "cloudext.co", value: "cloudext.co" }],
      pbxOptions: [],
      subscriptionOptions: [
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Inactive",
          value: "inactive",
        },
        {
          text: "Pause",
          value: "pause",
        },
      ],
      timeZoneOptions: time_zones,
      pmsTypeOptions: pmsType,
      dataToBeUpdate: {},
    };
  },
  components: {
    Multiselect,
    DataUpdateInfo,
  },
  props: {
    domainId: String,
    isEdit: Boolean,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    domain_form: {
      pbx: { required },
      domain_timezone: { required },
      ip: { required },
      domain_name: { required },
      extension_limit: { required },
      main_cid: {
        required,
        numeric,
        maxLength: maxLength(10),
        minLength: minLength(10),
      },
      main_name: { required },
      emr_cid: {
        required,
        numeric,
        maxLength: maxLength(10),
        minLength: minLength(10),
      },
      emr_name: { required },
      pms_id: {
        required: requiredIf(function () {
          if (
            this.domain_form.pms_type &&
            this.domain_form.pms_type.value == "asi"
          ) {
            return true;
          }
        }),
      },
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to get Domain list
    setValue() {
      // Methid is used to get server list
      PbxService.getPBXServerList()
        .then((response) => {
          if (response.status == false) {
            return Middleware.notification(response.message, "warning");
          }
          if (response.result.length !== 0) {
            response.result.forEach((element) => {
              this.pbxOptions.push({
                value: element.server_name,
                text: element.server_name,
                item: element,
              });
            });
          }
          // Methid is used to get domain list
          if (this.isEdit) {
            PbxService.getDomainDetailList(this.domainId)
              .then((response) => {
                if (response.status == false) {
                  return Middleware.notification(response.message, "warning");
                }
                if (response) {
                  this.domain_uuid = response.domain_uuid;
                  this.domain_form.pbx = this.pbxOptions.find(
                    (item) => item.value == response.pbx
                  );
                  this.domain_form.domain_subscription =
                    this.subscriptionOptions.find(
                      (item) => item.value == response.domain_subscription
                    );
                  this.domain_form.pms_type = this.pmsTypeOptions.find(
                    (item) => item.value == response.pms_type
                  );
                  this.domain_form.domain_name = response.domain_name;
                  this.domain_form.domain_enabled = response.domain_enabled;
                  this.domain_form.domain_description =
                    response.domain_description;
                  this.domain_form.ip = response.ip;
                  this.domain_form.domain_timezone = response.domain_timezone;
                  this.domain_form.stripe_customer_id =
                    response.stripe_customer_id;
                  this.domain_form.main_cid = response.main_cid;
                  this.domain_form.main_name = response.main_name;
                  this.domain_form.emr_cid = response.emr_cid;
                  this.domain_form.emr_name = response.emr_name;
                  this.domain_form.vpn_ip = response.vpn_ip;
                  this.domain_form.audiomsg = response.audiomsg;
                  this.domain_form.audiofile = response.audiofile;
                  this.domain_form.dailyvmaildel = response.dailyvmaildel;
                  this.domain_form.staffauth = response.staffauth;
                  this.domain_form.vm_admin_pin = response.vm_admin_pin;
                  this.domain_form.extension_limit = response.extension_limit;
                  this.dataToBeUpdate = {
                    created_by: response.created_by,
                    created_at: response.created_at,
                    updated_by: response.updated_by,
                    updated_at: response.updated_at,
                  };
                }
              })
              .catch((error) => {
                errorHandler(error);
              });
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to update pbx serve
    changePbxServer() {
      const response = this.pbxOptions.find(
        (item) => item.text == this.domain_form.pbx.value
      );
      this.domain_form.ip = response.item.server_ip;
    },
    // User Form Submit
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        this.domain_form.pbx = this.domain_form.pbx.value;
        this.domain_form.domain_subscription =
          this.domain_form.domain_subscription.value;
        this.domain_form.pms_type = this.domain_form.pms_type
          ? this.domain_form.pms_type.value
          : "";
        console.log(this.domain_form, "sdsdf");
        if (this.isEdit) {
          // Edit User
          PbxService.updateDomainDetail(this.domain_uuid, this.domain_form)
            .then((res) => {
              this.isBtnLoading = false;
              if (res.status == false) {
                return Middleware.notification(res.message, "danger");
              } else {
                Middleware.notification("Successfully updated !!", "success");
                this.$emit("submitted", res.result);
              }
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          this.domain_form.domain_name =
            this.domain_form.domain_name + "." + this.main_domain.value;
          // Add User
          PbxService.addDomainDetail({
            ...this.domain_form,
            extension_available: this.domain_form.extension_limit,
          })
            .then((res) => {
              this.isBtnLoading = false;
              if (res.status == false) {
                return Middleware.notification(res.message, "danger");
              } else {
                Middleware.notification("Successfully added !!", "success");
                this.$emit("submitted", res.result);
              }
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ isEdit ? "Update" : "Add New" }} Domain Details</h4>
        <hr />
      </div>
      <b-form @submit.prevent="onSubmit">
        <div class="row">
          <!-- Basic Details -->
          <h4 class="card-title">Basic Details</h4>
          <hr />

          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="select_domain">
              <span slot="label">
                <span>Select Domain </span>
                <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="main_domain"
                :options="domainOptions"
                :show-labels="false"
                placeholder="Search band"
                label="text"
                track-by="value"
                :allow-empty="false"
                id="select_domain"
              ></multiselect>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="sub_domain">
              <span slot="label">
                Sub Domain Name <span class="text-danger">*</span></span
              >
              <div class="row mx-1 align-items-end">
                <b-form-input
                  id="sub_domain"
                  type="text"
                  autocomplete="off"
                  v-model="domain_form.domain_name"
                  class="col-auto"
                  :class="{
                    'is-invalid':
                      submitted && $v.domain_form.domain_name.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.domain_form.domain_name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.domain_form.domain_name.required">
                    Domain is required.
                  </span>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="select_server">
              <span slot="label">
                Select Server <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="domain_form.pbx"
                :options="pbxOptions"
                @close="changePbxServer"
                :show-labels="false"
                placeholder="Search pbx server"
                label="text"
                track-by="value"
                id="select_server"
                :class="{
                  'is-invalid': submitted && $v.domain_form.pbx.$error,
                }"
              />
              <div
                v-if="submitted && $v.domain_form.pbx.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.domain_form.pbx.required"
                  >PBX server is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="ip">
              <span slot="label">
                <span>Server Ip </span> <span class="text-danger">*</span></span
              >
              <b-form-input
                id="ip"
                type="text"
                autocomplete="off"
                v-model="domain_form.ip"
                readonly
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="domain_timezone"
              label-for="time-zone-input"
            >
              <span slot="label"> Timezone </span>
              <multiselect
                v-model="domain_form.domain_timezone"
                :options="timeZoneOptions"
                :show-labels="false"
                placeholder="Search timezone"
                id="domain_timezone"
              ></multiselect>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="extension_limit">
              <span slot="label">
                Extension Limit <span class="text-danger">*</span></span
              >
              <b-form-input
                id="extension_limit"
                type="number"
                autocomplete="off"
                v-model="domain_form.extension_limit"
                :class="{
                  'is-invalid':
                    submitted && $v.domain_form.extension_limit.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.domain_form.extension_limit.required"
                  >Extension Limit is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="stripe_customer_id">
              <span slot="label"> Strip Id </span>
              <b-form-input
                id="stripe_customer_id"
                type="text"
                autocomplete="off"
                v-model="domain_form.stripe_customer_id"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <div class="mb-3">
              <label for="domain_subscription"> Domain Subscription </label>
              <multiselect
                v-model="domain_form.domain_subscription"
                :options="subscriptionOptions"
                :show-labels="false"
                label="text"
                track-by="value"
                id="select-sub"
              ></multiselect>
            </div>
          </div>
          <div class="col-md-4 col-sm-6">
            <div class="mb-3">
              <label for="pms_type">PMS Type</label>
              <multiselect
                v-model="domain_form.pms_type"
                :options="pmsTypeOptions"
                :show-labels="false"
                label="text"
                track-by="value"
                id="pms_type"
              ></multiselect>
            </div>
          </div>
          <div
            class="col-md-4 col-sm-6"
            v-if="
              this.domain_form.pms_type &&
              this.domain_form.pms_type.value == 'asi'
            "
          >
            <b-form-group class="mb-3" label-for="pms_id">
              <span slot="label">
                PMS Id <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="pms_id"
                type="text"
                autocomplete="off"
                v-model="domain_form.pms_id"
                :class="{
                  'is-invalid': submitted && $v.domain_form.pms_id.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.domain_form.pms_id.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.domain_form.pms_id.required"
                  >PMS id is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-8 col-sm-6">
            <b-form-group class="mb-3" label-for="domain_description">
              <span slot="label"> Description </span>
              <b-form-textarea
                id="domain_description"
                v-model="domain_form.domain_description"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-md-2 col-sm-2">
            <div class="mb-3">
              <label for="domain_enabled">Domain Status</label>
              <div class="form-check form-switch my-1" slot="domain_enabled">
                <input
                  class="form-check-input"
                  id="domain_enabled"
                  type="checkbox"
                  v-model="domain_form.domain_enabled"
                />
              </div>
            </div>
          </div>
          <div class="col-md-2 col-sm-2">
            <div class="mb-3">
              <label for="send_data_to_pms">Send data to PMS</label>
              <div class="form-check form-switch my-1" slot="send_data_to_pms">
                <input
                  class="form-check-input"
                  id="send_data_to_pms"
                  type="checkbox"
                  v-model="domain_form.is_send_data_to_pms"
                />
              </div>
            </div>
          </div>

          <!-- Default Settings -->
          <h4 class="card-title">Default Settings</h4>
          <hr />

          <div class="col-md-6 col-sm-6">
            <b-form-group class="mb-3" label-for="main_cid">
              <span slot="label">
                Outbound Caller ID <span class="text-danger">*</span></span
              >
              <b-form-input
                id="main_cid"
                type="text"
                autocomplete="off"
                v-model="domain_form.main_cid"
                :class="{
                  'is-invalid': submitted && $v.domain_form.main_cid.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.domain_form.main_cid.$error"
                class="invalid-feedback"
              >
                <span>
                  Outbound caller id is
                  {{
                    !$v.domain_form.main_cid.required
                      ? "required."
                      : !$v.domain_form.main_cid.numeric
                      ? "numeric."
                      : !$v.domain_form.main_cid.maxLength
                      ? "not more then 10."
                      : !$v.domain_form.main_cid.minLength
                      ? "not less then 10."
                      : ""
                  }}.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6 col-sm-6">
            <b-form-group class="mb-3" label-for="main_name">
              <span slot="label">
                Outbound Caller Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="main_name"
                type="text"
                autocomplete="off"
                v-model="domain_form.main_name"
                :class="{
                  'is-invalid': submitted && $v.domain_form.main_name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.domain_form.main_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.domain_form.main_name.required">
                  Outbound caller name is required.</span
                >
                <span v-if="!$v.domain_form.main_name.alpha">
                  Outbound caller name only accept charecter.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-md-6 col-sm-6">
            <b-form-group class="mb-3" label-for="emr_cid">
              <span slot="label">
                Emergency Caller ID
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="emr_cid"
                type="text"
                autocomplete="off"
                v-model="domain_form.emr_cid"
                :class="{
                  'is-invalid': submitted && $v.domain_form.emr_cid.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.domain_form.emr_cid.$error"
                class="invalid-feedback"
              >
                <span>
                  Emergency caller id is
                  {{
                    !$v.domain_form.emr_cid.required
                      ? "required."
                      : !$v.domain_form.emr_cid.numeric
                      ? "numeric."
                      : !$v.domain_form.emr_cid.maxLength
                      ? "not more then 10."
                      : !$v.domain_form.emr_cid.minLength
                      ? "not less then 10."
                      : ""
                  }}.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6 col-sm-6">
            <b-form-group class="mb-3" label-for="emr_name">
              <span slot="label">
                Emergency Caller Name
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="emr_name"
                type="text"
                autocomplete="off"
                v-model="domain_form.emr_name"
                :class="{
                  'is-invalid': submitted && $v.domain_form.emr_name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.domain_form.emr_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.domain_form.emr_name.required">
                  Emergency caller name is required.
                </span>
                <span v-if="!$v.domain_form.emr_name.alpha">
                  Emergency caller name only accept charecter.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="vpn_ip">
              <span slot="label"> VPN IP </span>
              <b-form-input
                id="vpn_ip"
                type="text"
                autocomplete="off"
                v-model="domain_form.vpn_ip"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="vm_admin_pin">
              <span slot="label"> Admin Pin </span>
              <b-form-input
                id="vm_admin_pin"
                type="text"
                autocomplete="off"
                v-model="domain_form.vm_admin_pin"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label
                for="dailyvmaildel"
                v-b-popover.hover.top="'Daily VoiceMail Delete'"
                >Daily VoiceMail Delete</label
              >
              <div class="form-check form-switch my-1" slot="dailyvmaildel">
                <input
                  class="form-check-input"
                  id="dailyvmaildel"
                  type="checkbox"
                  v-model="domain_form.dailyvmaildel"
                />
              </div>
            </div>
          </div>

          <!-- Voice Message Advertisement -->
          <h4 class="card-title">Voice Message Advertisement</h4>
          <hr />

          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="audiofile">
              <span slot="label"> Audio File </span>
              <b-form-select
                class="form-select"
                id="audiofile"
                v-model="domain_form.audiofile"
                type="text"
                autocomplete="off"
              >
                <b-form-select-option value="npport"
                  >No Port</b-form-select-option
                >
                <b-form-select-option value="nppay"
                  >No Pay</b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <div class="mb-3">
              <label for="audiomsg" v-b-popover.hover.top="'Audio Message'"
                >Audio Message</label
              >
              <div class="form-check form-switch my-1" slot="audiomsg">
                <input
                  class="form-check-input"
                  id="audiomsg"
                  type="checkbox"
                  v-model="domain_form.audiomsg"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6">
            <div class="mb-3">
              <label
                for="push_notification"
                v-b-popover.hover.top="'Mobile Push Notification'"
              >
                Mobile Push Notification
              </label>
              <div class="form-check form-switch my-1" slot="push_notification">
                <input
                  class="form-check-input"
                  id="push_notification"
                  type="checkbox"
                  v-model="domain_form.push_notification"
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="col-md-12">
            <b-button
              class="float-end ms-2 mb-3"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end mb-3"
              variant="outline-primary"
              type="submit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>

          <DataUpdateInfo :data-to-be-show="dataToBeUpdate" />
        </div>
      </b-form>
    </div>
  </div>
</template>
